module.exports = __webpack_public_path__ + "img/2.96751d91.jpg";